
export function logError(e: unknown, message: string) {
    if (window.ueLogError) {
        window.ueLogError(e, {
            logLevel: 'ERROR',
            attribution: 'Vibes',
            message,
        });
    } else {
        console.error(message, e);
    }
}
